import { CSSProperties } from 'react'
import styled from 'styled-components'

import { Typography } from 'primsell-shared-layer/components/atoms/typography'

interface PurchaseContainerProps {
  backgroundColor: CSSProperties['backgroundColor']
  borderColor: CSSProperties['borderColor']
}

interface TypeTextProps {
  textcolor: CSSProperties['color']
}

export const PoapStatusContainer = styled.div<PurchaseContainerProps>`
  padding: 6px 10px;
  width: 103px;
  border-radius: 10px;
  border: 0.6px solid ${({ borderColor }) => borderColor};
  background-color: ${({ backgroundColor }) => backgroundColor};
`

export const TypeText = styled(Typography)<TypeTextProps>`
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: center;
  color: ${({ textcolor }) => textcolor};
`
